var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427322413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25902",
    d: "M0 0H21C23.7614 0 26 2.23858 26 5V26L13 13L0 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2037 9.31067L22.6 4L24 5.46667L18.5925 12L14 8.10667L14.9162 6.21733L18.2037 9.31067Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginTick);
export default __webpack_public_path__ + "static/media/login-tick.53631bc2d250e66010fcb635a848c193.svg";
export { ForwardRef as ReactComponent };